import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiClientService } from 'libs/partner-web/shared/services';

@NgModule({
  imports: [CommonModule],
  providers: [ ApiClientService ]
})
export class SharedServicesModule {}
